<template>
  <div class="content">


    <div class="block-rounded block">
      <div
        class="block-header block-header-default d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center">
        <h3 class="block-title">{{ report.reference }}</h3>

        <div class="block-options d-flex justify-content-sm-end mt-sm-0 mt-2 flex-wrap gap-2">
          <div v-if="!report.is_settled" class="no-print">
            <button type="button" @click="settleReport" class="btn btn-sm btn-success" :disabled="loading">
              <i class="fa fa-fw fa-thumbs-up me-1"></i> {{ loading ? 'Processing...' : $t('button_settle') }}
            </button>
          </div>
          <span v-if="report.is_settled === true"
            class="fs-xs fw-semibold d-inline-block rounded-pill bg-success-light text-success px-3 py-2">
            Settled
          </span>
          <span v-else-if="report.is_settled === false"
            class="fs-xs fw-semibold d-inline-block rounded-pill bg-danger-light text-danger px-3 py-2">
            Rejected
          </span>
          <span v-else class="fs-xs fw-semibold d-inline-block rounded-pill bg-warning-light text-warning px-3 py-2">
            Pending
          </span>

          <button type="button" class="btn btn-alt-primary btn-sm" @click="printPage">
            <i class="si si-printer me-1"></i> {{ $t('button_print') }}
          </button>
        </div>
      </div>

      <div class="block-content" style="direction: ltr; text-align: left;">
        <div class="p-sm-0 p-xl-5">
          <div class="row mb-4 d-flex justify-content-between">
            <div class="col-6 fs-sm text-start">
              <p class="h3">{{ report.merchant?.first_name }} {{ report.merchant?.last_name }}</p>
              <address>
                {{ report.merchant?.role_title?.role_title }}<br>
                {{ report.merchant?.phone_number }}<br>
              </address>
            </div>
            <div class="col-6 fs-sm text-end">
              <p class="h3">{{ partner.title }}</p>
              <address>
                {{ report.creator?.first_name }} {{ report.creator?.last_name }},
                {{ report.creator?.role_title?.role_title }}<br>
                {{ report.creator?.phone_number }}<br>
              </address>
            </div>
          </div>
          <div class="table-responsive push">
            <table class="fs-sm table-bordered table">
              <thead>
                <tr class="text-center">
                  <th></th>
                  <th>{{ $t('table_reference') }}</th>
                  <th>{{ $t('table_qrcode') }}</th>
                  <th>{{ $t('table_receiver') }}</th>
                  <th>{{ $t('table_address') }}</th>
                  <th>{{ $t('table_mobile_number') }}</th>
                  <th>{{ $t('table_status') }}</th>
                  <th>{{ $t('table_cod') }}</th>
                  <th>{{ $t('table_delivery_price') }}</th>
                  <th>{{ $t('table_shipment_price') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(shipment, index) in shipments" :key="shipment._id" class="text-center print-row">
                  <td class="print-cell">{{ index + 1 }}</td>
                  <td class="print-cell">{{ shipment.reference }}</td>
                  <td class="print-cell">
                    <qrcode-vue :value="getQrCodeValue(shipment)" :size="70" level="H" class="qr-code" />
                  </td>
                  <td class="print-cell">{{ shipment.receiver_name }}</td>
                  <td>
                    <p class="fw-semibold mb-1">
                      {{ formatAddress(shipment) }}
                    </p>
                    <div class="text-muted">{{ shipment.receiver_address }}</div>
                  </td>
                  <td class="print-cell">{{ formatPhoneNumbers(shipment.receiver_sim_number) }}</td>
                  <td class="print-cell">{{ shipment.status_data?.title_ar }}</td>
                  <td class="print-cell">{{ shipment.grand_total }}</td>
                  <td class="print-cell">{{ shipment.delivery_price }}</td>
                  <td class="print-cell">{{ shipment.shipment_price }}</td>

                </tr>
                <tr>
                  <td colspan="9" class="fw-bold text-uppercase bg-body-light text-end">
                    {{ $t('input_total') }}</td>
                  <td class="fw-bold bg-body-light text-end">{{ report.total_shipments_value }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="fs-sm text-muted text-center">
            Thank you very much for doing business with us. We look forward to working with you again!
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue';
export default {
  components: {
    QrcodeVue
  },
  props: {
    report: {
      type: Object,
      required: true,
      default: () => ({
        _id: '',
        reference: '',
        total_shipments_value: 0,
        is_settled: null,
        user_id: '',
        merchant: {
          first_name: '',
          last_name: '',
          role: {},
          phone_number: ''
        },
        creator: {
          first_name: '',
          last_name: '',
          role: {},
          phone_number: ''
        }
      })
    },
    shipments: {
      type: Array,
      default: () => []
    },
    partner: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      incomeAccounts: [],
      expenseAccounts: [],
      company: { title: '' },
      expenseAccountId: null, // Use null instead of empty string
      deliveryManId: this.report.user_id || null,
      courierCash: 0,
      showSettleModal: false,
      loading: false,
      accountsLoading: false,
      qrCanvases: []
    };
  },
  mounted() {
    this.deliveryManId = this.report.user_id;
    this.fetchAllAccounts();
    console.log(this.report);
  },
  methods: {
    getQrCodeValue(shipment) {
      return shipment.reference;
    },
    showError(message) {
      Swal.fire({
        title: 'Error',
        text: message,
        icon: 'error'
      });
    },

    async settleReport() {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: 'Do you want to settle this report?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, settle it!',
        cancelButtonText: 'Cancel',
      });

      if (!result.isConfirmed) return;

      this.loading = true;

      axios.post('/return-report/approve', {
        report_id: this.report._id,
        expense_account_id: this.expenseAccountId,
      })
        .then(response => {
          Swal.fire({
            title: 'Settled!',
            text: 'The report has been settled successfully.',
            icon: 'success',
          });
        })
        .catch(error => {
          const errorMsg = error.response?.data?.message
            || error.message
            || 'An error occurred while settling the report.';
          this.showError(errorMsg);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async confirmSettlement() {
      await this.settleReport();
      this.showSettleModal = false;
    },

    printPage() {
      window.print();
    },

    generateQrCode(reference) {
      return `/api/qrcode?text=${encodeURIComponent(reference)}`;
    },

    formatAddress(shipment) {
      const city = shipment.AreaData?.city_name_ar || '';
      const governorate = shipment.AreaData?.governorate?.governorate_name_ar || '';
      return [city, governorate].filter(Boolean).join(', ');
    },

    async fetchAccounts(type_id) {
      try {
        const response = await axios.post('/accounts/get-accounts-of-type', {
          type_id: type_id
        });
        return response.data;
      } catch (error) {
        console.error('Error fetching accounts:', error);
        this.accountsError = 'Failed to load accounts';
        throw error;
      }
    },

    async fetchAllAccounts() {
      try {
        this.accountsLoading = true;
        this.accountsError = null;

        const [incomeAccounts, expenseAccounts] = await Promise.all([
          this.fetchAccounts('4'), // Income accounts
          this.fetchAccounts('5')  // Expense accounts
        ]);

        // Assign the fetched data to component state
        this.incomeAccounts = incomeAccounts || [];
        this.expenseAccounts = expenseAccounts || [];

      } catch (error) {
        console.error('Error fetching all accounts:', error);
        this.accountsError = 'Failed to load account data';
      } finally {
        this.accountsLoading = false;
      }
    },

    formatPhoneNumbers(numbers) {
      if (!numbers) return '';
      return Array.isArray(numbers) ? numbers.join('\n') : numbers;
    },
  }
};
</script>

<style scoped>
/* Hide during printing */
@media print {
  @page {
    size: A4;
    margin: 0.5cm;
  }

  body {
    padding: 0;
    margin: 0;
    font-size: 10pt;
  }

  .print-row {
    page-break-inside: avoid;
    page-break-after: auto;
  }

  .print-cell {
    padding: 2px;
    border: 1px solid #ddd;
  }

  .qr-code {
    width: 15mm !important;
    height: 15mm !important;
    display: block;
    margin: 0 auto;
  }

  .no-print {
    display: none !important;
  }
}

.qr-code {
  display: block;
  margin: 0 auto;
  border-radius: 4px;
  background: white;
}
</style>